// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 

// import nhb1 from "../../assets/cdp-image-1.png";
// import nhb2 from "../../assets/cdp-image-2.png";
// import nhb3 from "../../assets/cdp-image-3.png";
// import nhb4 from "../../assets/cdp-image-4.png";

// export default function NHB() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>CLUSTER DEVELOPMENT PROGRAMME from NHB</h1>
//                                   <p>The Government of India's Ministry of Agriculture and Farmers Welfare (MoA&FW) has established a new Horticulture Cluster Development programme to boost the country's horticulture sector's worldwide competitiveness. The National Horticulture Board has been designated as the Nodal Agency for the Cluster Development Program, which is a part of the NHB's Central Sector Scheme.</p>
//                                  <p>The Cluster Growth Program (CDP) aims to take advantage of horticultural clusters' geographic specialisation and encourage integrated and market-led development of preproduction, production, postharvest, logistics, branding, and marketing activities. The Ministry of Agriculture and Forestry has identified 53 horticultural clusters, 12 of which have been chosen for the program's pilot launch. The initiative will be expanded to cover all 53 clusters based on the lessons learned from the pilot experiment. The lessons learned from the pilot phase will assist policymakers and field workers in better execute the initiative in all horticultural clusters across India.</p>

//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                              <div>
//                                 <p>Based on the recommendations of the State/Central Government, a government/public sector body will be appointed as a Cluster Development Agency (CDA) to implement the CDP. This involvement of state government agencies through CDA will ensure that learnings are institutionalised and can be duplicated in the future for the creation of additional clusters around the country.</p>
//                                   <h2>Objectives</h2>
//                                   <p>The program's main goals are to:</p>
//                                   <p>(a) Address the concerns of the horticultural value chain in an integrated manner, from pre-production, production, postharvest management, and value addition to logistics, marketing, and branding, in order to improve competitiveness in both the home and export markets.</p>
                                  
//                                   <p>(b) Develop/expand/upgrade infrastructure for post-harvest handling of product, value addition, and market connections to reduce harvest and post-harvest losses.</p>
//                                   <p>(c) Facilitate the introduction of innovative technology and techniques to help focus cluster crops improve their global competitiveness.</p>
//                                   <p>(d) Facilitate resource integration, particularly the convergence of multiple government initiatives, in order to embed stakeholders in global value chains.</p>
//                                   <p>(e) Develop stakeholder capacity and increase farmer income through cluster-specific interventions, such as brand promotion.</p>

//                                   <h2>Clusters and Value chains identified for the Pilot launch of CDP :</h2>
//                                   <h2>The list of identified Crops and the Clusters in the pilot phase include :</h2>

                                  
//                              </div>
//                               </Col>
//                       </Row>
                      
//                       <Row>
//                         <Col xs={12} md={6} lg={6} className="mx-auto">
//                             <img src={nhb1} alt="NHB" className="img-fluid b-block mx-auto mb-3" />
//                           </Col>
//                           <Col xs={12} md={6} lg={6} className="mx-auto">
//                              <img src={nhb2} alt="NHB" className="img-fluid b-block mx-auto mb-3" />
//                           </Col>                                                    
//                       </Row>

//                       <Row>
//                           <Col lg={12} xl={12}>
//                               <h2>Financial Assistance</h2>
//                               <p>The National Horticulture Board will provide financial assistance to the Implementing Agencies through CDAs assigned to each Cluster. According to the area covered in the Cluster, it has been classified into three categories: Mega, Midi, and Mini. -</p>
                              
//                               <img src={nhb3} alt="NHB" className="img-fluid d-block mx-auto mb-3"/>
                              
//                               <p>* Area under focus crop in the Cluster.</p>

//                               <h2>Implementation Structure</h2>
//                               <p>The Cluster Growth Program (CDP) is intended to make use of horticultural clusters' geographic expertise in order to promote integrated and market-driven development of pre-production, production, postharvest, logistics, branding, and marketing activities. The program's implementation structure is as follows:</p>
//                               <p>1. The National Horticulture Board (NHB) will provide financial support and oversee the program's overall implementation.</p>
//                               <p>2. For each identified cluster, a government/public sector entity recommended by the State/Central Government shall be appointed as a Cluster Development Agency (CDA).</p>
//                               <p>3. For the smooth implementation of the programme, the CDA will establish a Cluster Development Cell (CDC) with a dedicated team of officers.</p>
//                               <p>4. The CDAs will select Implementing Agency/Agencies (IAs) for the Cluster's various verticals, namely:</p>
//                                     <ul>
//                                         <li>Pre-production and Production, through an open and transparent Call for Proposals process.</li>
//                                         <li>Post-Harvest Management & Addition of Value</li>
//                                         <li>Supply Chain Management, Marketing, and Branding</li>
//                               </ul>
//                               <p>5. NHB's Project Management Unit (PMU) will provide technical assistance to NHB and CDA in order for the Cluster Development Programme to be implemented effectively.</p>

// <img src={nhb4} alt="NHB" className="img-fluid d-block mx-auto mb-3"/>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// };


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";

export default function CDP() {
  return (
    <div className="bg-light py-5">
      <Container>

        {/* TITLE */}
        <Row>
          <Col>
            <h1>
              Cluster Development Programme (CDP) – NHB
            </h1>

            <p>
              The Cluster Development Programme (CDP) is a Government of India
              initiative to boost the competitiveness of the horticulture sector
              through cluster-based development.
            </p>

            <p>
              It focuses on building integrated infrastructure and strengthening
              the entire value chain from farm to market.
            </p>
          </Col>
        </Row>

        {/* OBJECTIVE */}
        <h2 className="section-title">
          <FaGlobe /> Objective of the Programme
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Improve productivity and crop quality</li>
          <li><FaCheckCircle /> Promote integrated development</li>
          <li><FaCheckCircle /> Enhance export competitiveness</li>
          <li><FaCheckCircle /> Reduce post-harvest losses</li>
          <li><FaCheckCircle /> Increase farmer income</li>
        </ul>

        {/* WHAT IS CLUSTER */}
        <h2 className="section-title">
          <FaList /> What is a Cluster?
        </h2>

        <p>
          A cluster is a region where a specific crop is grown in large quantities
          due to favorable conditions.
        </p>

        <ul className="custom-list">
          <li><FaCheckCircle /> Mango clusters</li>
          <li><FaCheckCircle /> Banana clusters</li>
          <li><FaCheckCircle /> Apple clusters</li>
          <li><FaCheckCircle /> Grapes clusters</li>
        </ul>

        {/* FOCUS AREAS */}
        <h2 className="section-title">
          <FaIndustry /> Key Focus Areas
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Pre-production & production</li>
          <li><FaCheckCircle /> Post-harvest infrastructure</li>
          <li><FaCheckCircle /> Supply chain & logistics</li>
          <li><FaCheckCircle /> Marketing & branding</li>
        </ul>

        {/* IMPLEMENTATION */}
        <h2 className="section-title">
          <FaIndustry /> Implementation Structure
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> NHB oversees the programme</li>
          <li><FaCheckCircle /> CDA appointed for each cluster</li>
          <li><FaCheckCircle /> CDC established for execution</li>
          <li><FaCheckCircle /> Implementing Agencies handle operations</li>
        </ul>

        {/* PROCESS */}
        <h2 className="section-title">
          <FaRocket /> How It Works
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Identify potential clusters</li>
          <li><FaCheckCircle /> Prepare development plan</li>
          <li><FaCheckCircle /> Infrastructure gap analysis</li>
          <li><FaCheckCircle /> Execution via agencies</li>
          <li><FaCheckCircle /> Monitoring & coordination</li>
        </ul>

        {/* BENEFITS */}
        <h2 className="section-title">
          <FaGlobe /> Key Benefits
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Integrated development</li>
          <li><FaCheckCircle /> Strong farm-to-market linkage</li>
          <li><FaCheckCircle /> Reduced wastage</li>
          <li><FaCheckCircle /> Better price realization</li>
          <li><FaCheckCircle /> Boost exports</li>
          <li><FaCheckCircle /> Increased investment</li>
        </ul>

        {/* HIGHLIGHTS */}
        <h2 className="section-title">
          <FaList /> Important Highlights
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> End-to-end value chain focus</li>
          <li><FaCheckCircle /> Public-private participation</li>
          <li><FaCheckCircle /> Technology adoption</li>
          <li><FaCheckCircle /> Scalable model</li>
        </ul>

        {/* HELP */}
        <h2 className="section-title">
          <FaHandsHelping /> How We Help You
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Cluster planning</li>
          <li><FaCheckCircle /> DPR preparation</li>
          <li><FaCheckCircle /> Government liaison</li>
          <li><FaCheckCircle /> Infrastructure planning</li>
          <li><FaCheckCircle /> Execution support</li>
        </ul>

        {/* CTA */}
        <h2 className="section-title">
          <FaRocket /> Get Started
        </h2>

        <p>
          Planning to develop or invest in a horticulture cluster?
          Connect with Apex Consultants for expert guidance and seamless execution.
        </p>

      </Container>
    </div>
  );
}